import { scan as scanConstants } from './../helpers';

export const SCAN_NODE_LABEL = 'nodeLabel';

export const getImageName = (scan) => {
  let image = scan && scan.imagePath;
  if (!image) {
    return image;
  }

  image = image.substring(image.lastIndexOf('\\') + 1).trim();
  return image;
};

// for images that are too difficult to correlate to a scan-key but do have a jira issue
// associated with it - this should be an exception, not common practice
export const IMAGE_TO_KEY_LIST = {
  ['MostFinalIEFDemoImageHashes5.8.E01']: 'SCAN-10',
  ['FOR508.engn']: 'SCAN-66'
};

export const getScanHitCount = (scan, isCcf) => {
  const individualCounts = getTypedHitCounts(scan, isCcf);
  let total = 0;
  for (let i = 0; i < Object.keys(individualCounts).length; i++) {
    total += individualCounts[Object.keys(individualCounts)[i]];
  }
  return total;
};

export const getTypeAverageDuration = (scan, isCcf) => {
  if (isCcf) {
    return scan && scan.averageCcfDuration || {};
  } else {
    return scan && scan.averageNcfDuration || {};
  }
};

export const getTypedHitCounts = (scan, isCcf) => {
  return (scan && scan.hitCounts[isCcf ? 'ccf' : 'ncf']) || {};
};

export const getTypedSourceCounts = (scan, isCcf) => {
  return scan && scan.sourceCounts[isCcf ? 'ccf' : 'ncf'] || {};
};

export const getTypedSourceAttributeCounts = (scan, isCcf) => {
  return scan && scan.sourceAttributeCounts[isCcf ? 'ccf' : 'ncf'] || {};
};

export const matchVMNode = (nodeName) => /-VM-/gi.exec(nodeName);
export const matchSeriesNode = (nodeName) => /\d\d\d/.exec(nodeName);

/**
 * Determines if the given node label doesn't match the node label specifier
 * defined on a JIRA SCAN ticket
 * @param {obj} scanTicket - a JIRA SCAN ticket object
 * @param {string} label - a label to try to match to scan ticket
 */
export const unmatchedNodeLabel = (scanTicket, label) => {
  if (!scanTicket) { return false; }

  // try to determine if the node label from ran job
  // is a match to the expected node label from SCAN.
  // 1. try to perform straight match
  // 2. job label may include multiple labels, check for inclusion
  // 3. determine series from regex and try match
  const matchAttempts = [
    () => scanTicket[scanConstants.SCAN_NODE_LABEL] !== label,
    () => {
      const regexp = new RegExp(`${scanTicket[scanConstants.SCAN_NODE_LABEL]}\\s*(&&)*`);
      const multipleLabelInclusion = regexp.test(label);
      return !multipleLabelInclusion;
    },
    () => {
      const jobNodeIsOfSeries = (/(\dxx|\d\d\d)/.test(label));
      const testLabel = jobNodeIsOfSeries ?
        /(\dxx|\d\d\d)/.exec(label)[0][0] + 'xx' :
        '';
      return !scanTicket[scanConstants.SCAN_NODE_LABEL].includes(testLabel);
    }
  ];

  let result = true;
  for (let i = 0; i < matchAttempts.length; ++i) {
    if (!result) { break; }
    const attemptResult = matchAttempts[i]();
    // first false means a match was found
    result = result && attemptResult;
  }
  return result;
};


// WEBPACK FOOTER //
// src/helpers/scans.js